import tetSideNavBg from 'assets/themes/tet/dao-left.png';
import womenDaySideNavBg from 'assets/themes/womenDay/footer-left.svg';
import womenDayLogo from 'assets/themes/womenDay/rose-left.png';
import nationalDaySideNavBg from 'assets/themes/0209/bg_menu0209.png';
import noelSideNavBg from 'assets/themes/noel/noel.png';
import vnFlag from 'assets/themes/0209/vn-flag.png';
import nationalDayBranch from 'assets/themes/0209/laco.svg';
import noelHeaderLogo from 'assets/themes/noel/noel_header.png';
import tetBranchLeft from 'assets/themes/tet/dao-left.png';
import cultureDaySideNavBg from 'assets/themes/cultureDay/footer_left.svg';
import cultureDayLogo from 'assets/themes/cultureDay/header_left.svg';
import { THEME_COLOR, GRAY_SCALE } from 'constants/ThemeConstant';

const PUBLIC_URL = process.env.PUBLIC_URL || '';
const LIGHT_THEME_LOGO = `${PUBLIC_URL}/img/nagaco.png`;
/** Icon/footer — cùng tỷ lệ với API *-sm.png (dark theme); không dùng banner ngang nagaco.png */
const LIGHT_THEME_LOGO_SM = `${PUBLIC_URL}/img/logo-nagaco-sm.png`;
const NATIONAL_DAY_THEME_LOGO = `${PUBLIC_URL}/img/nagaco_0209.png`;
const NATIONAL_DAY_THEME_LOGO_SM = `${PUBLIC_URL}/img/logo-nagaco-sm-0209.png`;

/** Icon hộp isometric (trắng) — data URL để <img> luôn load được */
const LIGHT_CARD_ICON =
    'data:image/svg+xml,' +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none"><g stroke="#FFFFFF" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"><path d="M24 8L40 16L24 24L8 16Z"/><path d="M8 16V32L24 40V24"/><path d="M40 16V32L24 40V24"/><path d="M24 8V24"/><path d="M24 24V40"/></g></svg>',
    );

/** Màu icon action mặc định — theo lightTheme (baseTheme) */
const DEFAULT_ACTION_ICON_COLORS = {
    active: THEME_COLOR.BLUE,
    inactive: THEME_COLOR.GOLD,
    edit: THEME_COLOR.BLUE,
    delete: THEME_COLOR.VOLCANO,
    detail: THEME_COLOR.CYAN,
    expand: GRAY_SCALE.GRAY,
    disabled: GRAY_SCALE.GRAY_LIGHT,
};

export const THEME_META = {
    light: {
        effect: null,
        sideNavBg: null,
        cardIcon: LIGHT_CARD_ICON,
        logo: {
            full: LIGHT_THEME_LOGO,
            sm: LIGHT_THEME_LOGO_SM,
        },
        actionIconColors: DEFAULT_ACTION_ICON_COLORS,
    },

    dark: {
        effect: null,
        sideNavBg: null,
        //cardIcon: vnFlag,
        actionIconColors: {
            active: '#4096FF',
            inactive: '#FAAD14',
            edit: '#69B1FF',
            delete: '#FF4D4F',
            detail: '#52C41A',
            expand: '#B4BED2',
            disabled: 'rgba(180, 190, 210, 0.35)',
        },
    },
    nationalDay: {
        effect: 'nationalDay',
        sideNavBg: nationalDaySideNavBg,
        sideNavBgImageOpacity: 0.62,
        cardIcon: vnFlag,
        logo: {
            full: NATIONAL_DAY_THEME_LOGO,
            sm: NATIONAL_DAY_THEME_LOGO_SM,
            decoration: nationalDayBranch,
            decorationClassName: 'national-day-branch-left',
            decorationWhen: 'expanded',
            badge: vnFlag,
            badgeWhen: 'expanded',
        },
        actionIconColors: {
            active: '#9F0000',
            inactive: '#FA8C16',
            edit: '#C41D1D',
            delete: '#FF4D4F',
            detail: '#D4A017',
            expand: '#6B1A1A',
            disabled: 'rgba(159, 0, 0, 0.3)',
        },
    },

    tet: {
        effect: 'tet',
        sideNavBg: tetSideNavBg,
        sideNavBgImageOpacity: 0.35,
        logo: {
            decoration: tetBranchLeft,
            decorationClassName: 'theme-logo-decoration theme-logo-decoration--tet',
            decorationWhen: 'expanded',
        },
        actionIconColors: {
            active: '#CF1322',
            inactive: '#FA8C16',
            edit: '#A8071A',
            delete: '#FF4D4F',
            detail: '#D48806',
            expand: '#7A1F1F',
            disabled: 'rgba(207, 19, 34, 0.3)',
        },
    },

    noel: {
        effect: 'snow',
        sideNavBg: noelSideNavBg,
        sideNavBgImageOpacity: 0.82,
        logo: {
            decoration: noelHeaderLogo,
            decorationClassName: 'national-day-branch-left theme-logo-decoration--noel',
            decorationWhen: 'expanded',
        },
        actionIconColors: {
            active: '#006E21',
            inactive: '#FA8C16',
            edit: '#237804',
            delete: '#CF1322',
            detail: '#D4A017',
            expand: '#2F4F2F',
            disabled: 'rgba(0, 110, 33, 0.3)',
        },
    },

    liberation: {
        actionIconColors: {
            active: '#F5222D',
            inactive: '#FAAD14',
            edit: '#CF1322',
            delete: '#A8071A',
            detail: '#D4B106',
            expand: '#7A1F1F',
            disabled: 'rgba(245, 34, 45, 0.3)',
        },
    },

    midAutumn: {
        actionIconColors: {
            active: '#FA8C16',
            inactive: '#FFC53D',
            edit: '#D46B08',
            delete: '#FF4D4F',
            detail: '#AD6800',
            expand: '#873800',
            disabled: 'rgba(250, 140, 22, 0.3)',
        },
    },

    womenDay: {
        effect: 'flower',
        sideNavBg: womenDaySideNavBg,
        sideNavBgImageOpacity: 0.8,
        logo: {
            decoration: womenDayLogo,
            decorationClassName: 'theme-logo-decoration theme-logo-decoration--women-day',
            decorationWhen: 'expanded',
        },
        actionIconColors: {
            active: '#D93672',      // Rose đậm - Active / Xác nhận
            inactive: '#E8A0B8',    // Dusty Rose - Inactive / Chưa kích hoạt
            edit: '#A67C00',        // Vàng olive - Chỉnh sửa
            delete: '#C0392B',      // Đỏ - Xóa
            detail: '#F0A202',      // Vàng cam - Xem chi tiết
            expand: '#8E3A59',       // Burgundy Rose - Mở rộng
            disabled: 'rgba(142, 58, 89, 0.30)',
        },
    },
    cultureDay: {
        effect: 'lotus',
        sideNavBg: cultureDaySideNavBg,
        sideNavBgImageOpacity: 0.8,
        logo: {
            decoration: cultureDayLogo,
            decorationClassName: 'theme-logo-decoration theme-logo-decoration--culture-day',
            decorationWhen: 'expanded',
        },
        actionIconColors: {
            active: '#822E01',
            inactive: '#E8A0B8',
            edit: '#A67C00',
            delete: '#C0392B',
            detail: '#F0A202',
            expand: '#8E3A59',
            disabled: 'rgba(142, 58, 89, 0.30)',
        },
    },
};

export const getSideNavThemeBg = (themeKey) => THEME_META[themeKey]?.sideNavBg ?? null;

export const getSideNavThemeBgImageOpacity = (themeKey) =>
    THEME_META[themeKey]?.sideNavBgImageOpacity ?? 0.38;

/** Màu icon action trên dòng table — theme thiếu key nào thì lấy màu mặc định của lightTheme */
export const getThemeActionIconColors = (themeKey) => ({
    ...DEFAULT_ACTION_ICON_COLORS,
    ...(THEME_META[themeKey]?.actionIconColors ?? {}),
});

export const getCardIcon = (themeKey) => THEME_META[themeKey]?.cardIcon ?? null;

export { getThemeLogoSrc, getThemeLogoExtras } from './themeLogo';
